import React from 'react';
import FooterNav from './FooterNav';

const About = ({ onNavigate, isActive, currentPage }) => {
  return (
    <section id="about" className={`page ${isActive ? 'active' : ''}`}>
      <div className="about-wrapper">
        <div className="about-container">
          <p className="about-tagline">From ideation to implementation.</p>
          <p className="about-description">
            Aidea Agency is a boutique creative marketing house transforming ideas into moments of impact. We collaborate with visionaries, cultural voices, and brands of influence seeking distinction.
          </p>
          <p className="about-description">
            Through high-touch collaboration and detail-driven execution, we design culturally relevant strategies and compose visuals that articulate experiential storytelling—work that resonates deeply, moves emotionally, and endures beyond the moment.
          </p>
        </div>
      </div>
      <FooterNav onNavigate={onNavigate} currentPage={currentPage} />
    </section>
  );
};

export default About;
